module.exports = __webpack_public_path__ + "img/timg.a013a0c1.gif";